import React from 'react';
import SkipButton from '../../SkipButton';
import InspectButton from '../../InspectButton';
import RiddleButton from '../../RiddleButton';
import ZoomOutButton from '../../ZoomOutButton';
import PowerupsInfoButton from './PowerupsInfoButton';
import './GameControls.css';

const GameControls = ({
  onSkip,
  onInspect,
  onInspectBlocked,
  onRiddleOpen,
  onZoomOut,
  onZoomOutBlocked,
  disableSkip,
  disableInspect,
  disableRiddle,
  disableZoomOut,
  isRiddleOpen,
  freeSkipsRemaining,
  freeInspectsRemaining,
  freeZoomOutsRemaining,
}) => {
  return (
    <div className="game-controls">
      <SkipButton
        onSkip={onSkip}
        disabled={disableSkip}
        freeSkipsRemaining={freeSkipsRemaining}
      />
      <InspectButton
        onInspect={onInspect}
        onBlockedClick={onInspectBlocked}
        disabled={disableInspect}
        freeInspectsRemaining={freeInspectsRemaining}
      />
      <ZoomOutButton
        onZoomOut={onZoomOut}
        onBlockedClick={onZoomOutBlocked}
        disabled={disableZoomOut}
        freeZoomOutsRemaining={freeZoomOutsRemaining}
      />
      <RiddleButton
        onOpen={onRiddleOpen}
        disabled={disableRiddle}
        isOpen={isRiddleOpen}
      />
      <PowerupsInfoButton />
    </div>
  );
};

export default GameControls;
